import React from 'react';
import {
    MDBContainer,
    MDBCol,
    MDBRow,
} from 'mdb-react-ui-kit';

import news from '../assets/gellary/news.jpeg'
import news1 from '../assets/gellary/news3.jpeg'
import news2 from '../assets/gellary/nesw2.jpeg'

export default function Gallaary() {
    return (

        <MDBRow>
            <h2>News Article Gallery</h2>
            <MDBCol lg={4} md={12} className='mb-4 mb-lg-0'>
                <img
                    src={news}
                    className='w-100 shadow-1-strong rounded mb-4'
                    alt='Boat on Calm Water'
                />

                <img
                    src={news2}
                    className='w-100 shadow-1-strong rounded mb-4'
                    alt='Wintry Mountain Landscape'
                />
            </MDBCol>

            <MDBCol lg={4} className='mb-4 mb-lg-0'>
                <img
                    src={news1}
                    className='w-100 shadow-1-strong rounded mb-4'
                    alt='Mountains in the Clouds'
                />

                <img
                    src={news1}
                    className='w-100 shadow-1-strong rounded mb-4'
                    alt='Boat on Calm Water'
                />
            </MDBCol>

            <MDBCol lg={4} className='mb-4 mb-lg-0'>
                <img
                    src={news2} className='w-100 shadow-1-strong rounded mb-4'
                    alt='Waves at Sea'
                />

                <img
                    src={news} className='w-100 shadow-1-strong rounded mb-4'
                    alt='Yosemite National Park'
                />
            </MDBCol>
        </MDBRow>
    );
}